const isIconConfigurationString = (config) => {
  return typeof config.name === "string";
};
const isIconConfigurationRegex = (config) => {
  return config.name instanceof RegExp;
};
export { isIconConfigurationRegex as a, isIconConfigurationString as i };
//# sourceMappingURL=types.js.map
